var exports = {
  "Zh": "automationBlock__kzo1w8",
  "Gz": "blockInner__6-tmwQ",
  "$6": "blockHeader__ZmCXwU",
  "Wg": "blockHeaderWithChildren__M79Cwu",
  "zc": "iconContainer__cWo73q",
  "ux": "headerDescription__xaurIr",
  "Bo": "headerEnd__tedUrp",
  "Tw": "blockContent__aWjaRu",
};

module.exports = exports;
